<template>
  <div class="flex mx-auto pt-14 w-100">
    <div class="pr-20">
      <div>
        <div
          v-for="page in pages"
          v-bind:key="page"
          @click="selectedPage = page"
          :class="`
                    ${
                      selectedPage === page
                        ? 'text-primary bg-primary-light'
                        : ' text-gray-600 '
                    }
                    pl-6
                    pr-6
                    text-smxs font-semibold py-0.5 my-0.5 cursor-pointer rounded-full  hover:text-primary transition`"
        >
          {{ page }}
        </div>
      </div>
    </div>

    <!-- OVERVIEW PAGE -->
    <div
      class="flex flex-col"
      v-if="selectedPage === 'Overview'"
      style="width: 600px"
    >
      <h1 class="text-xl text-gray-900 tracking-tight mb-2">
        Account Overview
      </h1>
      <div v-if="this.accountData" class="">
        <div class="text-xs text-gray-700">Email</div>
        <div class="text-gray-600">{{ accountData.email }}</div>

        <div class="text-xs text-gray-700 mt-4">First Name</div>
        <div class="text-gray-600">{{ accountData.firstName }}</div>

        <div class="text-xs text-gray-700 mt-4">Last Name</div>
        <div class="text-gray-600">{{ accountData.lastName }}</div>

        <div class="text-xs text-gray-700 mt-4">Company</div>
        <div class="text-gray-600">{{ accountData.company }}</div>

        <div class="text-xs text-gray-700 mt-4">Since</div>
        <div class="text-gray-600">
          {{ new Date(accountData.createdAtUnix * 1000).toLocaleString() }}
        </div>
      </div>
    </div>

    <!-- API KEY PAGE -->
    <div v-if="selectedPage === 'API Keys'" style="width: 600px">
      <h1 class="text-xl text-gray-900 tracking-tight mb-2">API Keys</h1>
      <div class="flex flex-col">
        <div class="text-sm text-gray-700 mb-1">Your API Key</div>
        <c class="text-gray-600 px-3 py-0.5 overflow-x-scroll" v-if="!apiKey">
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
        </c>
        <c class="text-gray-600 px-3 py-0.5 overflow-x-scroll" v-if="apiKey">
          {{ apiKey }}
        </c>
        <div v-if="confirm">
          <div class="text-red-600 mt-4">
            Are you sure? This action will deactivate your API key immediately,
            and is not reversible.
          </div>
          <div class="mt-4 cursor-pointer text-red-600">
            <u class="cursor-pointer hover:opacity-70" @click="newApiKey"
              >Yes, I am sure. Revoke my existing API Key.</u
            >
          </div>
        </div>
        <div class="text-xs text-gray-600 mt-1" v-else>
          This API Key has already been created and thus can no longer be
          viewed. If you would like to regenerate your key,
          <span @click="confirm = true" class="cursor-pointer hover:opacity-70"
            >click here.</span
          >
        </div>
        <!-- <div">New</div> -->
      </div>
    </div>

    <!-- WEBHOOK -->
    <div
      class="flex flex-col"
      v-if="selectedPage === 'Webhook Settings'"
      style="width: 600px"
    >
      <h1 class="text-xl text-gray-900 tracking-tight mb-2">Webhook</h1>
      <div class="flex flex-col">
        <div class="text-sm text-gray-700 mb-1">JWT Secret Key (Base64)</div>
        <c
          class="text-gray-600 px-3 py-0.5 overflow-x-scroll"
          v-if="!webhookKey"
        >
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
          <span>&#8226;</span>
        </c>
        <c
          class="text-gray-600 px-3 py-0.5 overflow-x-scroll"
          v-if="webhookKey"
        >
          {{ webhookKey }}
        </c>
        <div v-if="confirmWebhook">
          <div class="text-red-600 mt-4">
            Are you sure? This action will remove your existing webhook key, and
            is not reversible.
          </div>
          <div class="mt-4 cursor-pointer text-red-600">
            <u class="cursor-pointer hover:opacity-70" @click="newWebhookKey"
              >Yes, I am sure. Revoke my existing webhook key.</u
            >
          </div>
        </div>
        <div class="text-xs text-gray-600 mt-1" v-else>
          This webhook secret key has already been created and thus can no
          longer be viewed. If you would like to regenerate your key,
          <span
            @click="confirmWebhook = true"
            class="cursor-pointer hover:opacity-70"
            >click here.</span
          >
        </div>

        <div class="text-sm text-gray-700 mb-1 mt-6">
          The endpoint of your webhook
        </div>
        <div class="flex space-x-4">
          <input
            class="flex-1 focus:border-gray-400 outline-none border w-100 rounded-md px-4 py-2 bg-white border-1 border-gray-300 text-gray-900 text-sm"
            placeholder="Webhook Endpoint"
            v-model="webhookUrl"
          />
          <div
            :class="`w-100 rounded-md px-4 py-2 bg-primary-light border-1 ${
              webhookUrl === accountData.webhookUrl
                ? 'text-gray-500'
                : 'border border-green-600 text-green-600 cursor-pointer hover:opacity-75'
            }  transition  text-sm`"
            @click="updateWebhookUrl"
          >
            {{ updated ? "Updated" : "Update" }}
          </div>
        </div>
        <div class="text-xs text-gray-600 mt-1">
          This can be changed at anytime.
        </div>
        <div v-if="webhookError" class="text-sm text-red-600">
          *{{ webhookError }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAccountData,
  createNewApiKey,
  createNewWebhookKey,
  updateWebhookUrl,
  logout,
} from "@/api";

function isValidHttpUrl(string) {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
}

export default {
  data: () => {
    return {
      apiKey: "",
      accountData: null,
      confirm: false,
      confirmWebhook: false,
      webhookKey: "",
      pages: ["Overview", "API Keys", "Webhook Settings", "Logout"],
      selectedPage: "Overview",
      webhookUrl: "",
      updated: false,
      webhookError: "",
    };
  },
  mounted() {
    this.refreshAccountData();
  },
  watch: {
    selectedPage() {
      if (this.selectedPage === "Logout") {
        this.logout();
      }
    },
  },
  methods: {
    logout() {
      logout();
    },
    async newApiKey() {
      this.confirm = false;
      this.apiKey = await createNewApiKey();
    },
    async newWebhookKey() {
      this.confirmWebhook = false;
      this.webhookKey = await createNewWebhookKey();
    },
    async refreshAccountData() {
      this.accountData = await getAccountData();

      if (this.accountData) {
        this.webhookUrl = this.accountData.webhookUrl || "";
      }
    },
    async updateWebhookUrl() {
      if (this.webhookUrl === this.accountData.webhookUrl) {
        return;
      }

      if (!isValidHttpUrl(this.webhookUrl)) {
        this.webhookError = "Please enter a valid url";
        return;
      }

      this.webhookError = "";

      await updateWebhookUrl(this.webhookUrl);
      this.updated = true;

      setTimeout(() => {
        this.updated = false;
        this.refreshAccountData();
      }, 2000);
    },
  },
};
</script>
